import { Controller as BaseController } from '@hotwired/stimulus';

export default class Controller extends BaseController {
  static values = {
    color: Array,
    data: Array,
    label: Array,
    id: Number,
  };
  connect() {
    this.destroyExistingChart();
    const ctx = document.getElementById(`question-details-chart-${this.idValue}`);

    // Skip chart creation if canvas doesn't exist (e.g., during PDF export)
    if (!ctx) {
      return;
    }

    // Check if a chart instance already exists on this canvas
    if (ctx.chart) {
      ctx.chart.destroy();
      ctx.chart = null;
    }

    let maxvalue = Math.max(...this.dataValue);
    maxvalue = maxvalue > 10 ? maxvalue + 5 : maxvalue + 2;

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.labelValue,
        datasets: [
          {
            backgroundColor: this.colorValue,
            data: this.dataValue,
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: 'Contagem de respostas por alternativa',
            fontSize: 16,
          },
        },
        barThickness: 40,
        responsive: true,
        scales: {
          y: {
            max: maxvalue,
            min: 0,
          },
        },
      },
    });

    // Store reference on canvas element too
    ctx.chart = this.chart;
  }

  disconnect() {
    this.destroyExistingChart();
  }

  destroyExistingChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;

      // Also clean up canvas reference
      const ctx = document.getElementById(`question-details-chart-${this.idValue}`);
      if (ctx && ctx.chart) {
        ctx.chart = null;
      }
    }
  }
}
